import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
import { Button, ButtonType, DialogHeader } from '@checkmarx/cx-ui';
import ReactTooltip from 'react-tooltip';
import copy from 'copy-to-clipboard';
import PortalTextBox from '../../portal/portalTextBox';
import Dialog from 'material-ui/Dialog';

@inject('translationsStore','resetPasswordByManagerStore') @observer
export default class CopyPasswordDialog extends Component {

    resetPasswordByManagerStore = this.props.resetPasswordByManagerStore;
    translationsStore = this.props.translationsStore;
    copyButtonWrapper = React.createRef();

    copyToClipboard = () => {

        copy(this.resetPasswordByManagerStore.generatedPassword);

        const node = this.copyButtonWrapper.current;

        ReactTooltip.show(node);
    
        setTimeout(() => {

            ReactTooltip.hide(node);
        }, 2000);
    }

    render() {

        const title =   <DialogHeader
                            title={this.translationsStore.translate('TEMP_PASSWORD_MODEL_TITLE')}
                            displayCloseButton
                            closeClick={this.props.onClose}
                            displayCloseButton
                        />;

        const customContentStyle = {
            width: '475px',
            backgroundColor: '#FFFFFF'
        };
        
        return(
            <Dialog
                title={title}
                className='portal-confirm-dialog copy-confirm-dialog'
                titleClassName='portal-confirm-dialog-header alert-info'
                bodyClassName='portal-confirm-dialog-body'
                actionsContainerClassName='portal-confirm-dialog-actions'
                modal={true}
                contentStyle={customContentStyle}
                open={this.props.open}
            >
                <div>
                    {this.props.content}
                    <div style={{display: 'inline-block'}}>
                        <PortalTextBox 
                            id='tempPassword_textbox'
                            value={this.resetPasswordByManagerStore.generatedPassword}
                            width='315px'
                        />
                    </div>
                    <div
                        style={{display: 'inline-block'}}
                    >
                        <span
                            ref={this.copyButtonWrapper}
                            data-tip='tooltip'
                            style={{display: 'inline-block', width: '100%'}}
                        >
                        </span>
                        <Button 
                            onClick={this.copyToClipboard}
                            text={this.translationsStore.translate('TEMP_PASSWORD_MODEL_BUTTON')}
                        >
                        </Button>
                    </div>
                    <ReactTooltip
                        type='success'
                        effect='solid'
                    >
                        {this.translationsStore.translate('COPIED_TO_CLIPBOARD_TOOLTIP')}
                    </ReactTooltip>  
                </div>
            </Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/account/resetPasswordByManager/copyPasswordDialog.jsx